import React, { useState } from 'react';
import { useField, useFormikContext } from 'formik';
import Select from 'react-select';
import i18next from 'i18next';
import { CustomValueContainer } from './CustomValueContainer';
import './formSearchableSelect.scss';

const customStyles = {
  valueContainer: (provided) => ({
    ...provided,
    overflow: 'visible',
  }),
  placeholder: (provided, state) => {
    const isActive = state.selectProps.isFocused || state.hasValue || state.selectProps.inputValue;
    return {
      ...provided,
      position: 'absolute',
      top: isActive ? 0 : '50%',
      transition: '300ms',
      fontSize: isActive ? '1.2rem' : '1.4rem',
      transform: 'translateY(-50%)',
      backgroundColor: isActive && '#F7F7F7',
      color: isActive ? '#373C3D' : '#9A97A4',
      display: 'inline-block',
      fontFamily: 'Gotham Book',
      fontWeight: 400,
      textTransform: 'capitalize',
      padding: isActive && '0 0.5rem',
    };
  },
  menu: (provided, state) => {
    const {
      selectProps: { menuPlacement },
    } = state;
    return {
      ...provided,
      transform: `translateY(${menuPlacement === 'top' ? '-1rem' : '1rem'})`,
    };
  },
  control: () => ({
    display: 'flex',
    justifyContent: 'space-between',
  }),
};

export const FormDynamicSearchSelect = ({
  name, options, placeholder, menuPlacement, onChange, onInputChange, inputValue,
}) => {
  const [field, meta] = useField(name);
  const [focused, setFocused] = useState(false);
  const { setFieldValue } = useFormikContext();

  const currentLanguage = i18next.language;
  const error = meta.touched && meta.error ? meta.error : null;
  const value = options ? options.find((option) => option.value === field.value) : '';

  const handleBlur = () => {
    setFocused(false);
    if (onInputChange) onInputChange('');
    return field.onBlur;
  };

  const formatOptionLabel = ({ label, translationName }) => (translationName ? translationName[currentLanguage] : label);

  const handleSelectChange = (option) => {
    setFieldValue(field.name, option.value);
    if (onChange) onChange(option);
  };

  return (
    <div className="custom-input-wrapper">
      <Select
        placeholder={placeholder}
        options={options}
        name={field.name}
        inputValue={inputValue}
        isFocused={focused}
        onFocus={() => setFocused(true)}
        components={{ ValueContainer: CustomValueContainer }}
        formatOptionLabel={formatOptionLabel}
        value={value}
        onChange={handleSelectChange}
        onBlur={handleBlur}
        menuPlacement={menuPlacement}
        onInputChange={onInputChange}
        className={`react-select-container ${error ? 'error' : ''}`}
        classNamePrefix="react-select"
        styles={customStyles}
      />
      {error && <span className="custom-input__error-msg">{error}</span>}
    </div>
  );
};
